/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueTooltipComponent } from './sysque-tooltip.component';
import { DxTemplateModule, DxTooltipModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueTooltipComponent],
  imports: [CommonModule, DxTooltipModule, DxTemplateModule],
  exports: [SysqueTooltipComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueTooltipModule {}
